import styled from 'styled-components';

export const FormStepContainer = styled.div`
  max-width: 500px;
  padding: 48px 64px;
  background-color: #fff;
  box-shadow: 4px 12px 20px rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  box-sizing: border-box;

  @media screen and (max-width: 576px) {
    padding: 48px 24px;
  }

  .form-body {
    outline: none;
  }

  button {
    margin-bottom: 16px;
  }
`;

export const FormStepHeader = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  h3 {
    color: ${props => props.theme.colors.fontPrimary};
    font-weight: 600;
    font-size: 32px;
    margin-bottom: 16px;
  }
`;
